import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "sx"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Popover } from '@mui/material';
import { ArrowStyle } from './menu-popover.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Menu Popover component.
 *
 * @author Mikhail Siutsou
 * @function MenuPopover
 * @category components
 * @param {MenuPopoverProps} props menu popover.
 * @return {FC} Menu Popover component.
 */
var MenuPopover = function MenuPopover(_ref) {
  var children = _ref.children,
      sx = _ref.sx,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(Popover, _objectSpread(_objectSpread({
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    PaperProps: {
      sx: _objectSpread({
        p: 1,
        width: 200,
        overflow: 'inherit'
      }, sx)
    }
  }, otherProps), {}, {
    children: [/*#__PURE__*/_jsx(ArrowStyle, {
      className: "arrow"
    }), children]
  }));
};

export { MenuPopover };